<template>
	<main class="vx-row">
		<div class="vx-col w-full">
			<vx-card>
				<div >
					<img :src="imageLink(data)" alt="Banner" class="responsive card-img-top" />
				</div>
				<!-- Nama -->
				<section class="my-6 mx-4">
					<h2 class="mb-6"><strong>{{data.name}}</strong></h2>
					<div class="flex justify-between mb-4">
						<div class="flex items-center">
							<feather-icon svgClasses="mr-4" icon="UserIcon"></feather-icon>
							<strong>{{ data.jumlah_donatur ? data.jumlah_donatur : 0 }} donatur</strong>
						</div>
						<div class="flex justify-end">
							<feather-icon svgClasses="mr-4" icon="CalendarIcon"></feather-icon>
							<strong>{{ remainDay(data) }} hari lagi</strong>
						</div>
					</div>
					<!-- Progress -->
					<vs-progress color="warning" class="mb-4" :percent="donationPercent(data)"></vs-progress>
					<!-- / -->

					<!--  -->
					<div class="flex justify-between mb-6">
						<div>
							<h3 class="text-primary mb-2"><strong>Rp {{ formatRupiah(data.donasi_terkumpul) }}</strong></h3>
							<p class="text-left">terkumpul</p>
						</div>
						
						<div>
							<h3 class="text-primary mb-2"><strong>Rp {{ formatRupiah(data.donasi) }}</strong></h3>
							<p class="text-right">target</p>
						</div>
						
					</div>
					<!-- / -->

					<div class="mb-4">
						<share-social-media
							:link="campaignLink()"
							:name="campaignName()"
							:types="[{name: 'whatsapp', style: {backgroundColor: '#25D366'} }, {name: 'facebook', style: {backgroundColor: '#4267B2'}}]"
							:description="campaignDescription()"
						/>
					</div>

					<!-- Donasi skarang -->
					<vs-button @click.prevent="getCheckout" class="w-full">
						<strong class="text-warning">Donasi Sekarang</strong>
					</vs-button>
					<!-- / -->
				</section>
				<vs-divider></vs-divider>
				<h4 class="mb-4 mx-4"><strong>Penggalang Dana</strong></h4>
				<!-- / -->
				<!-- Info data -->
				<section class="vx-row mx-4 my-6 justify-between items-center rounded p-4">
					<div class="vx-col w-full lg:w-1/2">
						<div class="flex items-center">
							<img v-if="data.file_user_url === null" src="/assets/images/sahabat-zx/charity.svg" alt="" class="w-16 mr-4" />
							<img v-else :src="data.file_user_url" alt="" class="w-16  mr-4" />
							<div class="bg-light">
								<div class="flex items-center mb-2">
									<h5 class="mr-2 text-sm md:text-md lg:text-lg">
								        <strong>{{ data.user ? data.user.name : 'ZAX' }}</strong>
							        </h5>
							        <img v-if="data.user && data.user.status === 1" src="/verify.png" alt="" class="w-6" />
								</div>
								<p v-if="data.user && data.user.status === 1" class="text-grey text-sm md:text-md lg:text-lg">Identitas terverifikasi</p>
							</div>
							
						</div>
					</div>
					<div class="vx-col w-1/2">
						<div class="flex items-center justify-end">
						</div>
					</div>
				</section>
				<vs-divider></vs-divider>
				<section class="mb-6 mx-4">
					<h4 class="mb-4">Detail Donasi</h4>
					<div style="overflow: auto;" v-html="data.deskripsi"></div>
				</section>
				<!-- / -->
				<!-- Lihat Semua -->
				<div class="vx-row mb-4">
					<div class="vx-col w-full">
						<!-- <vs-button 
						    type="border"
						    icon-pack="feather"
						    icon="icon-chevron-down"
						    icon-after
						    class="mb-4 mx-auto"
						>
							<strong>Baca Selengkapnya</strong>
						</vs-button> -->
						<vs-divider></vs-divider>
					</div>
				</div>
				<!-- / -->
				<!-- Penerima Manfaat -->
				<div class="mb-6">
					<h4 class="mb-4"><strong>Penerima Manfaat</strong></h4>
					<div v-if="data.penerima_manfaat && data.penerima_manfaat.length < 1">
						<vs-alert color="warning" class="mb-8">
							<p class="text-center">
								<strong>Belum ada penerima manfaat saat ini</strong>
							</p>
						</vs-alert>
							
					</div>
					<div v-else>
						<div 
							class="mb-6"
							v-for="(item, i) in data.penerima_manfaat"
							:key="i"
						>
							<vx-card style="background: #f7f7f7;box-shadow: 0 0 0 #f7f7f7;">
								<div class="flex items-center">
									<div>
										<h5 style="color: green" class="mb-2">
											<strong>
												{{ item.name }}
											</strong>
										</h5>
										<p></p>
									</div>
								</div>
									
							</vx-card>
						</div>
					</div>
						
					<vs-button @click.prevent="$router.push(`/campaign/${data.id}/request-pm`)" class="w-full rounded">
						<strong class="text-white">Pengajuan Penerima Manfaat</strong>
					</vs-button>
				</div>
				<!-- / -->
				<!-- List Donatur & Doa -->
				<div class="mb-6" v-if="data.donatur_doa">
					<h4 class="mb-4"><strong>Doa</strong></h4>
					<div v-if="data.donatur_doa.length < 1">
						<vs-alert color="warning" class="mb-8">
							<p class="text-center">
								<strong>Belum ada doa saat ini</strong>
							</p>
						</vs-alert>
					</div>
					<div v-else>
						<div 
							class="mb-6"
							v-for="(item, i) in data.donatur_doa"
							:key="i"
						>
							<vx-card style="background: #f7f7f7;box-shadow: 0 0 0 #f7f7f7;">
								<div class="flex items-center">
									<div>
										<p style="color: green" class="mb-2">
											<strong>
												{{ item.name }}
											</strong>
										</p>
										<h5>
											<strong>{{ item.doa }}</strong>
										</h5>
									</div>
								</div>
									
							</vx-card>
						</div>
					</div>
				</div>
				<!-- / -->
				<vs-divider></vs-divider>
				<!--  -->
				
			</vx-card>
		</div>
	</main>
</template>
<script>
import CampaignSlider from './components/CampaignSlider.vue';
import CampaignAuthor from './components/CampaignAuthor.vue';
import { mapState } from 'vuex';
import { PMRole } from '@/assets/utils/user_roles';
import {PMCode} from '@/assets/utils/campaign';
let meta = [
	{ property: 'og:url', content: process.env.VUE_APP_FE },
	{ property: 'og:type', content: 'website' },
	{ property: 'og:title', content: 'Website Zakat Express' },
	{ property: 'og:image', content: '/zx.png' },
	{ property: 'og:description', content: '-' }
];

export default {
	metaInfo: {
		meta
	},
  methods: {
	campaignLink() {
		return `${process.env.VUE_APP_FE}/campaign/view/${this.$route.params.slug_and_id}`;
	},
	campaignName() {
		if(this.data) {
			return this.data.name;
		}

		return 'Campaign';
	},
	campaignDescription() {
		if(this.data && this.data.deskripsi) {
			return this.truncateString( this.replaceText(this.data.deskripsi.replace(/<\/?[^>]+(>|$)/g, "")), 20 );
		}

		return '';
	},
	getCheckout() {
		let linkDonation = `/campaign/donation-amount/${this.$route.params.slug_and_id}`;
		if(this.$route.params.referal)  {
			linkDonation += `?ref=${this.$route.params.referal}`;
		}

		this.$router.push(linkDonation);
	},
    imageLink (campaign) {
      if (campaign && campaign.file !== null && campaign.file != '') {
        return `${process.env.VUE_APP_STORAGE}/${campaign.file}`;
      }
				
      return '/loading.gif';
    },
    donationPercent (campaign) {
      return Math.ceil((parseInt(campaign.donasi_terkumpul) / parseInt(campaign.donasi)) * 100)
    },
    remainDay (campaign) {
      const mulai = new Date(campaign.mulai),
        selesai = new Date(campaign.selesai),
        timeDifferent = selesai.getTime() - mulai.getTime(),
        dayMilsec = 1000 * 60 * 60 * 24

      return timeDifferent / dayMilsec
    },
    back () {
      this.$router.go(-1)
    },
	getCampaign() {
		// get id from slug
		const arrSlug = this.$route.params.slug_and_id.split('-'),
				id = Buffer.from(arrSlug[ arrSlug.length - 1 ], 'base64').toString();

		// Check if exist in state
		this.$store.dispatch('campaign/getDetail', id)
		.then(campaign => {
			// if(!campaign.donatur_doa) {
			// 	campaign.donatur_doa = []
			// }
			Object.assign(this.data, campaign);
			this.data.deskripsi = this.replaceText(this.replaceText(this.data.deskripsi));
			this.data.deskripsi = this.replaceText(this.replaceText(this.data.deskripsi));
			this.data.file_user_url = null
			if(this.data.user && this.data.user.file !== null) {
				this.data.file_user_url = process.env.VUE_APP_STORAGE + '/' + this.data.user.file;
			}

			// Update open grap meta
			let link = `${process.env.VUE_APP_FE}/campaign/view/${this.$route.params.slug_and_id}`;
			let name = this.data ? this.data.name : 'Campaign';
			if(this.$route.params.referal) {
				link += `/${this.$route.params.referal}`;
			}

			meta[0].content = link;
			meta[2].content = this.data ? this.data.name : 'Campaign';
			meta[3].content = this.imageLink(campaign);
			meta[4].content = this.campaignDescription();
			
			// Update meta via DOM
			const titleNodeList = document.querySelectorAll('meta[property="og:title"]'),
				titleArray = [...titleNodeList],
				urlNodeList = document.querySelectorAll('meta[property="og:url"]'),
				urlArray = [...urlNodeList],
				descNodeList = document.querySelectorAll('meta[property="og:description"]'),
				descArray = [...descNodeList],
				imgNodeList = document.querySelectorAll('meta[property="og:image"]'),
				imgArray = [...imgNodeList];
			
			titleArray.forEach(meta => meta.setAttribute('content', name));
			urlArray.forEach(meta => meta.setAttribute('content', link));
			descArray.forEach(meta => meta.setAttribute('content', this.campaignDescription()));
			imgArray.forEach(meta => meta.setAttribute('content', this.imageLink(campaign)));

		})
		.catch(e => {
			console.error(e)
			// this.$router.push('/404-notfound')

			return false
		})
	}
  },
  components: {
    CampaignSlider,
    CampaignAuthor,
	ShareSocialMedia: () => import('@/views/components/ShareSocialMedia.vue')
  },
  data: () => ({
    PMRole,
    data: {
		penerima_manfaat: [],
		file: null,
		name: '',
		description: ''
	}
  }),
  computed: {
    ...mapState('auth', ['profile'])
  },
  created () {
	this.getCampaign();
  }
}
</script>
<style>
	#campaign-card .vx-card{
		box-shadow: none;
		border: 1px solid #ccc;
	}
</style>